export default __webpack_public_path__ + "static/potatoes-cooking-e270ba7b753639ad7a1ad7f506564efa.svg";